export default __webpack_public_path__ + "static/media/No-Connection.71251d84.png";